var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.stats),function(stat){return _c('DynamicStat',{key:stat.id,attrs:{"stat":stat}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }